import React, { createContext, useContext, useState, useEffect } from 'react';
import dataJson from '../../data/data.json';
import { getApiBase } from '../../utils/api';

const DataContext = createContext();

export function useData() {
  return useContext(DataContext);
}

const DEFAULT_SITE_SETTINGS = {
  company: { name: 'Alo Alla', tagline: '' },
  contact: { email: '', phone: '', address: '' },
  social: { facebook: '', instagram: '', linkedin: '', twitter: '', whatsapp: '' },
  footer: { copyright: '', termsUrl: '/terms-and-conditions', privacyUrl: '#' },
};

function buildStateFromRoot(root) {
  const {
    navigation,
    testimonials,
    faqs,
    tabs,
    posts,
    pricing,
    Homepages,
    InnerPage,
    landingPage,
    siteSettings,
  } = root;

  return {
    tabs,
    faqs,
    posts,
    pricing,
    homepage: Homepages,
    innerpage: InnerPage,
    navigation,
    testimonials,
    landingpage: landingPage,
    siteSettings: {
      company: { ...DEFAULT_SITE_SETTINGS.company, ...(siteSettings?.company || {}) },
      contact: { ...DEFAULT_SITE_SETTINGS.contact, ...(siteSettings?.contact || {}) },
      social: { ...DEFAULT_SITE_SETTINGS.social, ...(siteSettings?.social || {}) },
      footer: { ...DEFAULT_SITE_SETTINGS.footer, ...(siteSettings?.footer || {}) },
    },
  };
}

export default function DataProvider({ children, ...props }) {
  const [data, setData] = useState(() => buildStateFromRoot(dataJson));

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${getApiBase()}/site-content`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (!json.success || json.data == null) throw new Error('Réponse invalide');
        if (cancelled) return;
        setData(buildStateFromRoot(json.data));
      } catch (e) {
        console.warn('[DataProvider] MongoDB / site-content indisponible, utilisation de data.json :', e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}
